/**
 * NBC Holidays REST API Client
 *
 * Separate client instance from `nbcClient` because the school-holiday
 * endpoints live on the locale-agnostic NBC base URL (no /de/ prefix).
 *
 * @module services/api/nbc/nbcHolidaysClient
 */

import { RestClient } from '../shared/restClient';
import { NBC_HOLIDAYS_CONFIG } from './config';

export const nbcHolidaysClient = new RestClient({
  baseURL: NBC_HOLIDAYS_CONFIG.ENDPOINT,
  timeout: NBC_HOLIDAYS_CONFIG.TIMEOUT,
  retryConfig: {
    retries: NBC_HOLIDAYS_CONFIG.RETRY.maxAttempts,
    retryDelay: (retryCount) => {
      return NBC_HOLIDAYS_CONFIG.RETRY.initialDelay * Math.pow(2, retryCount - 1);
    },
  },
});
